export default __webpack_public_path__ + "static/media/home.634b2b24.svg";